(function (root) {
  function weeks(name) {
    const match = String(name || '').match(/\b(\d+)\s*weeks?\b/i);
    return match ? Number(match[1]) : null;
  }

  function storefrontPlan(plan) {
    return [4, 6, 8, 10, 12].includes(weeks(plan?.name));
  }

  // One savings rule on every surface: the saving is measured against the same pack's one-time price
  // and shown as a whole-number percentage rounded down, so a saving is never overstated (15.88% shows 15%).
  function wholePercent(was, now) {
    if (!(was > 0 && now < was)) return 0;
    return Math.floor(((was - now) * 100 / was) + 1e-9);
  }
  function savings(was, now) {
    if (!(was > 0 && now < was)) return null;
    const rounded = wholePercent(was, now);
    return { rounded, label: rounded + '%' };
  }

  function packCount(title) {
    if (/^\s*one\s+(?:bag|box)\b/i.test(title)) return 1;
    const match = String(title || '').match(/^\s*(\d+)\s*(?:-?pack|bags?|boxes?)\b/i);
    return match ? Number(match[1]) : null;
  }

  function offer(product, variant, plan) {
    if (!plan || !/12oz|cups/i.test(product?.title || '')) return null;
    if (/\b(variety|mixed|assorted|assortment|sampler|bundle|kit)\b/i.test(product.title + ' ' + variant?.title)) return null;
    const count = packCount(variant?.title);
    const singles = product.variants.filter(item => packCount(item.title) === 1 && Number.isSafeInteger(item.price) && item.price > 0);
    const single = singles.length === 1 ? singles[0] : null;
    if (!count || !Number.isSafeInteger(count) || /12oz/i.test(product.title) && count >= 12 || !single || !Number.isSafeInteger(plan.price) || plan.price <= 0) return null;
    if (!Number.isSafeInteger(single.price * count) || single.price * count <= plan.price) return null;
    const total = savings(single.price * count, plan.price);
    const extra = savings(variant.price, plan.price);
    if (!total || !extra) return null;
    const percent = (was, now) => wholePercent(was, now) + '%';
    return {
      count,
      noun: /cups/i.test(product.title) ? 'boxes' : 'bags',
      total: percent(single.price * count, plan.price),
      extra: percent(variant.price, plan.price),
      baseline: single.price * count,
      savedCents: single.price * count - plan.price
    };
  }

  function tileSavings(offer, formatMoney) {
    if (!offer || !formatMoney) return '';
    return offer.count > 1
      ? 'Save ' + formatMoney(offer.savedCents) + ' total (' + offer.total + ')'
      : 'Save ' + formatMoney(offer.savedCents) + ' with subscription (' + offer.total + ')';
  }

  function allocation(variant, cadenceWeeks) {
    return variant?.allocations.find(plan => storefrontPlan(plan) && weeks(plan.name) === cadenceWeeks) || null;
  }

  // The storefront plan closest to a requested interval; a tie goes to the shorter interval.
  function nearestPlan(plans, wanted) {
    const list = (plans || []).filter(storefrontPlan);
    if (!list.length) return null;
    if (!(Number(wanted) > 0)) return list.find(plan => weeks(plan.name) === 4) || list[0];
    return list.reduce((best, plan) => {
      const d = Math.abs(weeks(plan.name) - wanted), bd = Math.abs(weeks(best.name) - wanted);
      return d < bd || (d === bd && weeks(plan.name) < weeks(best.name)) ? plan : best;
    });
  }

  function cadenceNote(requested, applied) {
    return 'Every ' + requested + ' weeks is not available for this pack, so we applied every ' + applied + ' weeks, the closest interval. You can choose another one.';
  }

  // Visible message when Subscribe & Save is chosen without a delivery interval.
  function planError(scope, show) {
    let node = scope?.querySelector('[data-alac-plan-error]');
    if (!show) { if (node && !node.hidden) node.hidden = true; return node || null; }
    if (!node) {
      const anchor = scope?.querySelector('product-form');
      if (!anchor) return null;
      node = anchor.ownerDocument.createElement('p');
      node.className = 'alac-plan-error';
      node.dataset.alacPlanError = '';
      node.setAttribute('role', 'alert');
      anchor.before(node);
    }
    setText(node, 'Choose a delivery interval to start your subscription.');
    node.hidden = false;
    return node;
  }

  function read(scope) {
    const script = scope?.querySelector('.recharge-picker__container [data-alac-plan-variants]');
    if (!script) return null;
    if (script.alacPlanData) return script.alacPlanData;
    try { script.alacPlanData = JSON.parse(script.textContent); return script.alacPlanData; } catch (_) { return null; }
  }

  function activeVariant(scope, data) {
    const id = scope.querySelector('product-form form [name="id"], .product-form form [name="id"], .product-variant-id')?.value;
    return data.variants.find(variant => String(variant.id) === String(id)) ||
      data.variants.find(variant => String(variant.id) === String(scope.querySelector('.option-container-size input:checked')?.dataset.vid)) ||
      data.variants[0];
  }

  function money(scope, cents) {
    const data = read(scope);
    return new Intl.NumberFormat(data?.locale || 'en-US', { style: 'currency', currency: data?.currency || 'USD' }).format(cents / 100);
  }

  function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }

  function selectedWeeks(scope) {
    const picker = scope.querySelector('.recharge-picker__container');
    const label = picker?.querySelector('.recharge-option label.selected') || picker?.querySelector('.recharge-option label:not([data-value="custom"])');
    if (!label) return null;
    return label.dataset.value === 'custom' ? Number(picker.querySelector('[name="weeks"]')?.value) : weeks(label.dataset.value);
  }

  function selectCadence(picker, label) {
    if (!picker || !label) return;
    picker.querySelectorAll('.recharge-option label').forEach(node => {
      node.classList.toggle('selected', node === label);
      const input = node.querySelector?.('input[type="radio"]');
      if (input) input.checked = node === label;
    });
    const custom = label.dataset.value === 'custom';
    const editor = picker.querySelector('.custom-quantity__selector');
    if (editor) editor.style.display = custom ? 'block' : 'none';
    picker.querySelectorAll('.recharge-option').forEach(option => { option.style.display = custom ? 'none' : ''; });
  }

  function syncQuantityEditor(scope) {
    const picker = scope.querySelector('variant-radios');
    if (!picker) return;
    const custom = !!picker.querySelector('.option-container-custom input:checked');
    picker.querySelectorAll('.custom-quantity__selector').forEach(box => {
      if (custom) box.style.setProperty('display', 'block', 'important');
      else box.style.removeProperty('display');
    });
    picker.querySelectorAll('.option-container').forEach(box => {
      // The tile grid uses display:flex!important in the theme stylesheet.
      if (custom) box.style.setProperty('display', 'none', 'important');
      else box.style.removeProperty('display');
    });
  }

  function closeEditor(scope, close) {
    const picker = close?.closest('.recharge-picker__container');
    if (picker) {
      selectCadence(picker, picker.querySelector('.recharge-option label:not([data-value="custom"])'));
      return 'frequency';
    }
    const variants = close?.closest('variant-radios');
    if (!variants) return null;
    const firstPack = variants.querySelector('.option-container__first label');
    if (!firstPack) return null;
    variants.querySelectorAll('.custom-quantity__selector, .option-container').forEach(box => { box.style.removeProperty('display'); });
    firstPack.click();
    const form = scope.querySelector('product-form form, .product-form form');
    const quantity = [...scope.querySelectorAll('[name="quantity"]')].find(input => input.form === form) || form?.querySelector('[name="quantity"]');
    if (quantity) { quantity.value = 1; quantity.dispatchEvent(new Event('change', { bubbles: true })); }
    return 'quantity';
  }

  function sync(scope) {
    const data = read(scope);
    if (!data?.variants?.length) return null;
    syncQuantityEditor(scope);
    const form = scope.querySelector('product-form form, .product-form form');
    const variant = activeVariant(scope, data);
    if (!form || !variant) return null;
    const subInput = scope.querySelector('[name="tabinner"][value="subscribeandsave"]');
    let subscribed = !!subInput?.checked;
    const picker = scope.querySelector('.recharge-picker__container');
    let cadence = selectedWeeks(scope);
    let chosen = allocation(variant, cadence);
    const storefrontAllocations = variant.allocations.filter(storefrontPlan);
    const note = picker?.querySelector('[data-alac-cadence-note]');
    if (subscribed && !chosen && storefrontAllocations.length) {
      // No plan for the requested interval (a typed 7 or 14 weeks, or a cadence this pack lacks):
      // apply the closest plan explicitly and say so, instead of silently switching.
      // A typed custom value stays in its field while the shopper edits it; the plan is the closest one.
      const requested = cadence;
      const typed = picker.querySelector('.recharge-option label.selected')?.dataset.value === 'custom';
      chosen = nearestPlan(storefrontAllocations, requested);
      cadence = weeks(chosen.name);
      if (!typed) {
        const label = [...picker.querySelectorAll('.recharge-option label')].find(node => weeks(node.dataset.value) === cadence);
        if (label) {
          selectCadence(picker, label);
        } else {
          const weeksInput = picker.querySelector('[name="weeks"]');
          if (weeksInput) weeksInput.value = cadence;
          selectCadence(picker, picker.querySelector('.recharge-option label[data-value="custom"]'));
        }
      }
      if (requested && note) {
        picker.alacAppliedWeeks = cadence;
        setText(note, cadenceNote(requested, cadence));
        note.hidden = false;
      }
    } else if (note && !note.hidden && picker.alacAppliedWeeks !== cadence) {
      note.hidden = true;
      setText(note, '');
      delete picker.alacAppliedWeeks;
    }
    const canSubscribe = storefrontAllocations.length > 0;
    if (subscribed && !canSubscribe) {
      const buyOnce = scope.querySelector('[name="tabinner"][value="buyonce"]');
      if (buyOnce) {
        buyOnce.checked = true;
        buyOnce.dispatchEvent(new Event('change', { bubbles: true }));
      }
      subscribed = false;
      chosen = null;
    }
    // The purchase mode can change through a radio's change event (including keyboard
    // and accessibility controls), without a click on its wrapping label.
    if (picker) picker.style.display = subscribed ? 'block' : 'none';
    if (subscribed && chosen && !picker.querySelector('.recharge-option label.selected')) {
      const label = [...picker.querySelectorAll('.recharge-option label')].find(node => weeks(node.dataset.value) === cadence);
      if (label) selectCadence(picker, label);
    }
    if (subInput) {
      subInput.disabled = !canSubscribe;
      const wrap = subInput.closest('.oc__subscription-tabinner-item');
      if (wrap) wrap.hidden = !canSubscribe;
    }
    const planInput = form.querySelector('[name="selling_plan"]') || (() => {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; form.append(input); return input;
    })();
    const nextId = subscribed && chosen ? String(chosen.id) : '';
    if (planInput.value !== nextId) {
      planInput.value = nextId;
      planInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!subscribed || chosen) planError(scope, false);
    const selectedSaving = chosen ? savings(variant.price, chosen.price) : null;
    const bestPlan = storefrontAllocations.reduce((min, plan) => (min === null || plan.price < min.price ? plan : min), null);
    const perkSaving = selectedSaving || (bestPlan ? savings(variant.price, bestPlan.price) : null);
    setText(scope.querySelector('[data-alac-sub-perk-save]'), perkSaving ? 'Save ' + perkSaving.label + ' on every delivery' : 'Flexible deliveries');
    const activePrice = subscribed && chosen ? chosen.price : variant.price;
    scope.querySelectorAll('.option-container-size').forEach(card => {
      const cardVariant = data.variants.find(item => String(item.id) === String(card.querySelector('[data-vid]')?.dataset.vid));
      if (!cardVariant) return;
      const cardPlan = allocation(cardVariant, cadence);
      const cardPrice = subscribed && cardPlan ? cardPlan.price : cardVariant.price;
      setText(card.querySelector('.variant-price'), money(scope, cardPrice));
      const saving = cardPlan ? savings(cardVariant.price, cardPlan.price) : null;
      let badge = card.querySelector('.alac-sub-save');
      if (!badge) { badge = document.createElement('span'); badge.className = 'alac-sub-save'; card.querySelector('label')?.append(badge); }
      // Same baseline as the Subscribe card: this pack's own one-time price.
      const badgeText = saving ? 'Save ' + money(scope, cardVariant.price - cardPlan.price) + ' with subscription (' + saving.label + ')' : '';
      setText(badge, subscribed ? badgeText : '');
      badge.hidden = !subscribed || !badgeText;
      const radio = card.querySelector('[data-vid]');
      if (radio) radio.setAttribute('aria-label', radio.value + ', ' + money(scope, cardPrice) + (subscribed && badgeText ? ', ' + badgeText.toLowerCase() : ''));
      card.querySelectorAll('.sa-unitprice').forEach(node => {
        const base = Number(node.dataset.unitPrice);
        if (base) setText(node, money(scope, base * cardPrice / cardVariant.price) + '/' + node.dataset.referenceUnit);
      });
    });
    const custom = scope.querySelector('variant-radios .custom-quantity__selector');
    if (custom) {
      setText(custom.querySelector('.variant-price'), money(scope, activePrice));
      const badge = custom.querySelector('.oc__quantity-discount-box');
      if (badge) {
        const buyOnceSaving = Number(badge.dataset.discount);
        const label = subscribed && selectedSaving ? 'Save ' + money(scope, variant.price - chosen.price) + ' with subscription (' + selectedSaving.label + ')' : buyOnceSaving > 0 ? 'Save ' + buyOnceSaving + '%' : '';
        setText(badge, label);
        badge.hidden = !label;
      }
      custom.querySelectorAll('.sa-unitprice').forEach(node => {
        const base = Number(node.dataset.unitPrice);
        if (base) setText(node, money(scope, base * activePrice / variant.price) + '/' + node.dataset.referenceUnit);
      });
    }
    return { variant, cadence, chosen, subscribed, activePrice };
  }

  const api = { weeks, storefrontPlan, wholePercent, savings, packCount, offer, tileSavings, allocation, nearestPlan, cadenceNote, planError, read, activeVariant, selectedWeeks, selectCadence, syncQuantityEditor, closeEditor, sync };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.AlacSubscriptionPricing = api;
})(typeof window !== 'undefined' ? window : globalThis);
